import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=5861079e&scoped=true&"
import script from "./DynamicList.vue?vue&type=script&lang=js&"
export * from "./DynamicList.vue?vue&type=script&lang=js&"
import style0 from "./DynamicList.vue?vue&type=style&index=0&id=5861079e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861079e",
  null
  
)

export default component.exports